// extracted by mini-css-extract-plugin
var _1 = "Setting-lQ6Zd";
var _2 = "SettingCheckbox-LFdWt";
var _3 = "SettingExplanation-ehf7N";
var _4 = "SettingTextContainer-E3cgk";
var _5 = "SettingTitle-j9aIl";
var _6 = "Settings-kkTpT";
export { _1 as "Setting", _2 as "SettingCheckbox", _3 as "SettingExplanation", _4 as "SettingTextContainer", _5 as "SettingTitle", _6 as "Settings" }
